import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { Notification } from "../../store/admin/notificationsStore";

export interface NotificationListParams {
  page?: number;
  limit?: number;
  type_of_addressee?: string;
  status?: string;
  search?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface NotificationListBody {
  data?: Notification[];
  meta?: ListMeta;
}

export interface NotificationListResult {
  data: Notification[];
  meta?: ListMeta;
}

export function useNotificationsList(params: NotificationListParams = {}) {
  const companyId = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.notifications.list(companyId, params),
    queryFn: ({ signal }) =>
      getJson<NotificationListBody>(
        "/notificationsList",
        { page: 1, limit: 10, ...params },
        { signal },
      ).then((body) => ({ data: body.data ?? [], meta: body.meta })),
    staleTime: 5 * 60_000,
  });
}
